<template>
  <button
    v-bind:class="{'btn btn-close':true,'scale-btn':scale}"
    ondragstart="return false;"
    @click="handleClose"
    @touchstart="handleScale"
    @mousedown="handleScale"
    @mouseup="handleRestore"
    @mouseout="handleRestore"
    @touchcancel="handleRestore"
    @touchend="handleRestore"
  ></button>
</template>
<script>
export default {
  name: "btnClose",
  data() {
    return {
      scale: false,
    };
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    handleScale() {
      this.scale = true;
    },
    handleRestore() {
      this.scale = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-close {
  cursor: pointer;
  width: 0.3rem;
  height: 0.3rem;
  background-image: url(~@/assets/img/app/UI_common_button_X_01.png);
  background-repeat: no-repeat;
  background-size: cover;
}
.scale-btn {
  -webkit-transform: scale(0.95);
  transform: scale(0.95);
}
</style>